import React from 'react';
import PropTypes from 'prop-types';

import useProductCustomerPhotosReviewsMin from 'data-hooks/useProductCustomerPhotosReviews/useProductCustomerPhotosReviewsMin';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import useProductCustomerPhotosReviews from 'data-hooks/useProductCustomerPhotosReviews';
import useModularPDPCustomerPhotosAndReviews from 'data-hooks/useModularPDPCustomerPhotosAndReviews';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import { useBazaarVoiceEnabled } from 'hooks/useBazaarVoice';
import PDPCustomerPhotosUI from './PDPCustomerPhotosUI';
import BVPDPCustomerPhotosUI from './BVPDPCustomerPhotosUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';

const PDPCustomerPhotosInner = ({ slug }) => {
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const { loading, error, data } = useProductCustomerPhotosReviewsMin();
  const initialModularCustomerData = useModularPDPCustomerPhotosAndReviews();

  const modularCustomerData = pdpIsModularBYOProduct
    ? {}
    : initialModularCustomerData;

  const {
    data: { selectedMaterial },
  } = usePDPFabricFilters(slug, false);

  // Prefetch the full data
  useProductCustomerPhotosReviews(data?.id, { ssr: false });

  if (loading) {
    return <PDPCustomerPhotosUI loading />;
  }

  if (error) {
    return 'Something went wrong, please try again';
  }

  if (!data) {
    return null;
  }

  const { id, name } = data;

  const { customer_photos_min, customer_reviews } = pdpIsModularBYOProduct
    ? modularCustomerData
    : data;

  return (
    <PDPCustomerPhotosUI
      id={id}
      name={name}
      customerReviews={customer_reviews}
      customerPhotos={customer_photos_min}
      pdpIsModularBYOProduct={pdpIsModularBYOProduct}
      selectedMaterial={selectedMaterial}
    />
  );
};

PDPCustomerPhotosInner.propTypes = {
  slug: PropTypes.string,
};

const PDPCustomerPhotos = ({ slug }) => {
  const isBVEnabled = useBazaarVoiceEnabled();

  if (isBVEnabled) {
    return <BVPDPCustomerPhotosUI />;
  }

  if (!slug) return null;

  return (
    <SuspenseWithLoader>
      <PDPCustomerPhotosInner slug={slug} />
    </SuspenseWithLoader>
  );
};

PDPCustomerPhotos.propTypes = {
  slug: PropTypes.string,
};

export default PDPCustomerPhotos;
